import { useState } from "react";
import styles from "./../styles.module.css";
import { MetaFisica } from "../../../../model/PlanoDeTrabalho/CronogramaExecucao";
import Modal from "react-responsive-modal";
import Table from "../../../../components/TableConstructor";
import RowCronoFisico from "../../../../components/TableConstructor/Row/RowCronoFisico";

type Props = {
  passarPagina: Function;
  voltarPagina: Function;
  listaMetas: MetaFisica[];
};

function ExecucaoFisico({ passarPagina, voltarPagina, listaMetas }: Props) {
  const [showModel, setModal] = useState(false);

  return (
    <div>
      <h2 className={styles.titulo}>
        2.1. Cronograma de Execução Físico:
      </h2>

      <Table
        listTitle={["Etapa/Fase", "Descrição da Meta", "Indicador", "Duração"]}
        styleList={[1, 0, 1, 1, 0]}
      >
        {listaMetas.map((metaObj, index) => (
          <RowCronoFisico key={index} metaObj={metaObj}>
            {""}
          </RowCronoFisico>
        ))}
      </Table>

      <Modal
        open={showModel}
        onClose={() => setModal(false)}
        center
        classNames={{
          modal: "customModal",
        }}
      ></Modal>

      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            passarPagina();
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </div>
  );
}

export default ExecucaoFisico;
